'use client';

import cx from 'classnames';
import { useAtomValue } from 'jotai';
import Link from 'next/link';
import { useState } from 'react';

import CheveronDown from '@flipster/ui/assets/svgs/chevron-down.svg';

import { filteredGlossaryTermsAtom } from '../jotai';
import { GlossaryPageGlossaryTermFragment } from '../query.generated';
import styles from './index.module.scss';

// prettier-ignore
const indexItems = ['#', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

const IndexNav = ({ className }: { className?: string }) => {
  const filteredGlossaryTerms = useAtomValue(filteredGlossaryTermsAtom);
  const termByIndex = filteredGlossaryTerms.reduce(
    (memo, term) => {
      let index = term.name?.toLowerCase().at(0);
      if (!index) return memo;
      if (/^[^a-zA-Z]$/.test(index)) index = '#';
      if (memo[index]) return memo;
      return { ...memo, [index]: term };
    },
    {} as Record<string, GlossaryPageGlossaryTermFragment>,
  );
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className={cx(styles.nav, { [styles.open]: isOpen }, className)} id='glossary-index-nav'>
      <h2 className={styles.heading}>Glossary A to Z</h2>
      <ol className={styles.ol}>
        {indexItems.map((indexItem) => (
          <li className={cx(styles.li, { [styles.liLastIndex]: indexItem === indexItems.at(-1) })} key={indexItem}>
            <Link
              className={styles.link}
              href={termByIndex[indexItem] ? { hash: termByIndex[indexItem].slug } : '#'}
              role='button'
              tabIndex={-1}
              aria-disabled={!termByIndex[indexItem]}
            >
              {indexItem.toUpperCase()}
            </Link>
          </li>
        ))}

        <li className={cx(styles.li, styles.liEllipsis)}>
          <span className={styles.text}>...</span>
        </li>

        <li className={cx(styles.li, styles.liToggleOpen)}>
          <button
            type='button'
            className={styles.button}
            onClick={() => setIsOpen((prev) => !prev)}
            aria-hidden
            tabIndex={-1}
          >
            <CheveronDown />
          </button>
        </li>
      </ol>
    </nav>
  );
};

export default IndexNav;
